(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sw--brand-story-carousel"] && !Shopify.designMode) return;
  try {
    
  $('.brand_story_slider').slick({
  dots: false,
  infinite: false,
  speed: 300,
  slidesToShow: 1,
  variableWidth: true
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sw--video-slider"] && !Shopify.designMode) return;
  try {
    
  $('.video_slider').slick({
  dots: false,
  infinite: false,
  speed: 300,
  slidesToShow: 3,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});

  
// 
// video_elem
// 
const videos = document.querySelectorAll('.video_elem');

videos.forEach(video => {
    video.addEventListener('play', function() {
        // Pause other videos when a new video starts playing
        videos.forEach(vid => {
            if (vid !== this && !vid.paused) {
                vid.pause();
                vid.currentTime = 0; // Reset video to start
                vid.poster = vid.getAttribute('poster'); // Reset poster
            }
        });
    });
});
  
const playButtons = document.querySelectorAll('.video_play_btn');

playButtons.forEach(button => {
    button.addEventListener('click', function() {
        const video = this.parentElement.querySelector('.video_elem');

        if (video.paused || video.ended) {
            // Play the video
            video.play();
            this.innerHTML = "";
        } else {
            // Pause the video
            video.pause();
            this.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 50 50" fill="none"><rect width="50" height="50" rx="24" fill="white"/><path d="M18 13V38L38 25.5L18 13Z" fill="black"/></svg>';
        }
    });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonial"] && !Shopify.designMode) return;
  try {
    
  $(document).ready(function(){
  $('#testimonial').slick({
  centerMode: true,
  centerPadding: '0px',
  slidesToShow: 3,
    infinite:true,
    prevArrow: "<button class='testimonial-list__arrow prev-next-button prev-next-button--prev prev'>                <span class='visually-hidden'>Previous</span><svg focusable='false' width='17' height='14' class='icon icon--nav-arrow-left  icon--direction-aware ' viewBox='0 0 17 14'>        <path d='M17 7H2M8 1L2 7l6 6' stroke='currentColor' stroke-width='1.3' fill='none'></path>      </svg></button>",
    nextArrow: "<button class='testimonial-list__arrow prev-next-button prev-next-button--next next'>                <span class='visually-hidden'>Next</span><svg focusable='false' width='17' height='14' class='icon icon--nav-arrow-right  icon--direction-aware ' viewBox='0 0 17 14'>        <path d='M0 7h15M9 1l6 6-6 6' stroke='currentColor' stroke-width='1.3' fill='none'></path>      </svg></button>",
  responsive: [
    {
      breakpoint: 768,
      settings: {
        arrows: false,
        centerMode: true,
        centerPadding: '40px',
        slidesToShow: 3,
  arrows:true
      }
    },
    {
      breakpoint: 480,
      settings: {
        arrows: false,
        centerMode: true,
        centerPadding: '40px',
        slidesToShow: 1,
  arrows:false
      }
    }
  ]
});
    });

  } catch(e) { console.error(e); }
})();
})();
